import EVSection from './components/EVSection'
import './App.css'

function App() {
  return (
    <div className="App">
      <EVSection />
    </div>
  )
}

export default App
